import { stitch } from 'keo';
import PropTypes from 'prop-types';
import r from 'render-dom';
import { connect, Provider } from 'react-redux';

import { store } from '../redux';

const propTypes = {
    alertComponent: PropTypes.func.isRequired,
};

/**
 * Renders any alerts in the Alert store one at a time
 *
 * @author Ben Larkins <ben@sellerlabs.com>
 */
const render = ({ props: { alertComponent } }) => {
    const Alert = connect(
        (state) => ({
            alert: state.get(0),
        })
    )(alertComponent);

    return (
        r(Provider, { store }, [
            r(Alert),
        ])
    );
};

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/components/shared/Alert/AlertContainer/index.js